import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "category-browse__product-card" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "category-browse__product-img" }
const _hoisted_4 = {
  key: 0,
  class: "category-browse__not-avbl"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "category-browse__product-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: $setup.notAvailableInFinish ? $setup.linkWithoutFinish : $props.link,
      class: "category-browse__product"
    }, [
      ($setup.availabilitySlug !== $setup.avblActive)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['category-browse__flag', $setup.availabilitySlug && `category-browse__flag--${$setup.availabilitySlug}`])
          }, [
            _createElementVNode("span", null, _toDisplayString($props.availability), 1 /* TEXT */)
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_3, [
        ($setup.notAvailableInFinish)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($props.translations.UnavailableInSelectedFinish), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        ($setup.notAvailableInFinish)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: $setup.firstFinishInArray ? $setup.firstFinishInArray : $setup.fallbackImage,
              alt: $props.displayName,
              class: "category-browse__grey-out"
            }, null, 8 /* PROPS */, _hoisted_5))
          : (_openBlock(), _createElementBlock("img", {
              key: 2,
              src: $setup.finishImagePath ? $setup.finishImagePath : $setup.fallbackImage ,
              class: _normalizeClass([$setup.finishImagePath ? '' : 'state-missing-image']),
              alt: $props.displayName
            }, null, 10 /* CLASS, PROPS */, _hoisted_6))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", null, _toDisplayString($props.displayName), 1 /* TEXT */)
      ])
    ], 8 /* PROPS */, _hoisted_2)
  ]))
}